import { useTranslation } from "react-i18next";
import DetailedFeatureItem from "./DetailedFeatureItem";
import TGA_01 from "../../Images/TGA_01_TemplateSetup-Photoroom.png";
import TGA_02 from "../../Images/TGA_02_DefineRooms.png";
import TGA_03 from "../../Images/TGA_03_DefineItems.png";
import TGA_04 from "../../Images/TGA_04_Reports.png";

export default function TgaFeaturesDetailed({ onTryDemoClickFunction: _onTryDemoClickFunction }: { onTryDemoClickFunction?: () => void }) {
    const { t } = useTranslation();

    const items = [
        {
            image: TGA_01,
            title: t("TemplateLibrarySetupTitle"),
            text: t("TemplateLibrarySetupText"),
            backgroundClass: "xl:bg-detailedFeaturesGlassOne xl:bg-cover xl:bg-center xl:bg-no-repeat rounded-[20px]"
        },
        {
            image: TGA_02,
            title: t("RoomSystemDefinitionTitle"),
            text: t("RoomSystemDefinitionText"),
            backgroundClass: "bg-[#FF61041A] xl:bg-#F6F6F6"
        },
        {
            image: TGA_03,
            title: t("LoadSetupDetailingTitle"),
            text: t("LoadSetupDetailingText"),
            backgroundClass: "xl:bg-detailedFeaturesGlassTwo xl:bg-cover xl:bg-center xl:bg-no-repeat rounded-[20px]"
        },
        {
            image: TGA_04,
            title: t("AutomatedDocumentationReportsTitle"),
            text: t("AutomatedDocumentationReportsText"),
            backgroundClass: "bg-[#FF61041A] xl:bg-#F6F6F6"
        },
    ];

    return (
        <div className="flex flex-col bg-#F6F6F6 px-[30px] lg:px-[100px]">
            <h2 className="text-lg xl:text-2xl uppercase font-bold p-[30px] xl:p-[60px] text-center">{t("TgaDetailedFeaturesTitle")}</h2>
            {items.map((item, index) => (
                <DetailedFeatureItem
                    key={index}
                    image={item.image}
                    title={item.title}
                    text={item.text}
                    backgroundClass={item.backgroundClass}
                    index={index} />
            ))}
        </div>
    )
}